
export const obtenerVehiculosPorSucursal = (token: string, sucursal: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ sucursal }),
    };
    fetch(apiUrl + "/vehiculos/por-sucursal", requestOptions)
      .then((res) => res.json())
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
};

export const editarVehiculo = (token: string, data: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(apiUrl + "/vehiculo/editar", requestOptions)
      .then((res) => res.json())
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
};
import { ApiResponse } from '../../types';

const apiUrl: string = import.meta.env.VITE_ADMIN_URL;

export const crearVehiculo = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body }),
    };

    fetch(apiUrl + "/vehiculo/crear", requestOptions)
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
